'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var path = require('path');

var os = require('os');

var uuid = require('uuid/v4');

exports.filter = function (iterable, filterer) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, keep;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 2;
            _iterator = _asyncIterator(iterable);

          case 4:
            _context.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 18;
              break;
            }

            value = _step.value;
            _context.next = 10;
            return _awaitAsyncGenerator(filterer(value));

          case 10:
            keep = _context.sent;

            if (keep) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("continue", 15);

          case 13:
            _context.next = 15;
            return value;

          case 15:
            _iteratorAbruptCompletion = false;
            _context.next = 4;
            break;

          case 18:
            _context.next = 24;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 24:
            _context.prev = 24;
            _context.prev = 25;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 29;
              break;
            }

            _context.next = 29;
            return _awaitAsyncGenerator(_iterator.return());

          case 29:
            _context.prev = 29;

            if (!_didIteratorError) {
              _context.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context.finish(29);

          case 33:
            return _context.finish(24);

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 20, 24, 34], [25,, 29, 33]]);
  }))();
}; // Not just sort, because the sorter is given all the values and should return
// them all sorted


exports.sortAll = function (iterable, sorter) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var values, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, value, _iterator5, _step5, _value;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            values = [];
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context2.prev = 3;
            _iterator2 = _asyncIterator(iterable);

          case 5:
            _context2.next = 7;
            return _awaitAsyncGenerator(_iterator2.next());

          case 7:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
              _context2.next = 13;
              break;
            }

            value = _step2.value;
            values.push(value);

          case 10:
            _iteratorAbruptCompletion2 = false;
            _context2.next = 5;
            break;

          case 13:
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t0;

          case 19:
            _context2.prev = 19;
            _context2.prev = 20;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context2.next = 24;
              break;
            }

            _context2.next = 24;
            return _awaitAsyncGenerator(_iterator2.return());

          case 24:
            _context2.prev = 24;

            if (!_didIteratorError2) {
              _context2.next = 27;
              break;
            }

            throw _iteratorError2;

          case 27:
            return _context2.finish(24);

          case 28:
            return _context2.finish(19);

          case 29:
            _context2.next = 31;
            return _awaitAsyncGenerator(sorter(values));

          case 31:
            values = _context2.sent;
            _iterator5 = _createForOfIteratorHelper(values);
            _context2.prev = 33;

            _iterator5.s();

          case 35:
            if ((_step5 = _iterator5.n()).done) {
              _context2.next = 41;
              break;
            }

            _value = _step5.value;
            _context2.next = 39;
            return _value;

          case 39:
            _context2.next = 35;
            break;

          case 41:
            _context2.next = 46;
            break;

          case 43:
            _context2.prev = 43;
            _context2.t1 = _context2["catch"](33);

            _iterator5.e(_context2.t1);

          case 46:
            _context2.prev = 46;

            _iterator5.f();

            return _context2.finish(46);

          case 49:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 15, 19, 29], [20,, 24, 28], [33, 43, 46, 49]]);
  }))();
};

exports.take = function (iterable, n) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var i, _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, value;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(n <= 0)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            i = 0;
            _iteratorAbruptCompletion3 = false;
            _didIteratorError3 = false;
            _context3.prev = 5;
            _iterator3 = _asyncIterator(iterable);

          case 7:
            _context3.next = 9;
            return _awaitAsyncGenerator(_iterator3.next());

          case 9:
            if (!(_iteratorAbruptCompletion3 = !(_step3 = _context3.sent).done)) {
              _context3.next = 19;
              break;
            }

            value = _step3.value;
            _context3.next = 13;
            return value;

          case 13:
            i++;

            if (!(i >= n)) {
              _context3.next = 16;
              break;
            }

            return _context3.abrupt("return");

          case 16:
            _iteratorAbruptCompletion3 = false;
            _context3.next = 7;
            break;

          case 19:
            _context3.next = 25;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t0 = _context3["catch"](5);
            _didIteratorError3 = true;
            _iteratorError3 = _context3.t0;

          case 25:
            _context3.prev = 25;
            _context3.prev = 26;

            if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
              _context3.next = 30;
              break;
            }

            _context3.next = 30;
            return _awaitAsyncGenerator(_iterator3.return());

          case 30:
            _context3.prev = 30;

            if (!_didIteratorError3) {
              _context3.next = 33;
              break;
            }

            throw _iteratorError3;

          case 33:
            return _context3.finish(30);

          case 34:
            return _context3.finish(25);

          case 35:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 21, 25, 35], [26,, 30, 34]]);
  }))();
};

exports.map = function (iterable, mapper) {
  return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, value;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _iteratorAbruptCompletion4 = false;
            _didIteratorError4 = false;
            _context4.prev = 2;
            _iterator4 = _asyncIterator(iterable);

          case 4:
            _context4.next = 6;
            return _awaitAsyncGenerator(_iterator4.next());

          case 6:
            if (!(_iteratorAbruptCompletion4 = !(_step4 = _context4.sent).done)) {
              _context4.next = 13;
              break;
            }

            value = _step4.value;
            _context4.next = 10;
            return mapper(value);

          case 10:
            _iteratorAbruptCompletion4 = false;
            _context4.next = 4;
            break;

          case 13:
            _context4.next = 19;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](2);
            _didIteratorError4 = true;
            _iteratorError4 = _context4.t0;

          case 19:
            _context4.prev = 19;
            _context4.prev = 20;

            if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
              _context4.next = 24;
              break;
            }

            _context4.next = 24;
            return _awaitAsyncGenerator(_iterator4.return());

          case 24:
            _context4.prev = 24;

            if (!_didIteratorError4) {
              _context4.next = 27;
              break;
            }

            throw _iteratorError4;

          case 27:
            return _context4.finish(24);

          case 28:
            return _context4.finish(19);

          case 29:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 15, 19, 29], [20,, 24, 28]]);
  }))();
};

exports.replaceStartWith = function (s, r) {
  var matcher = new RegExp('^' + r);
  return s.replace(matcher, '');
};

exports.tmpdir = function () {
  return path.join(os.tmpdir(), uuid());
};